import { useCallback } from 'react';
import styled from 'styled-components';

import { MedicalLeavePuePayer } from '@dreryk/egabinet-ezla-frontend-api';
import { PayerIdentificationNumberType } from '@dreryk/egabinet-ezla-published-language-api';

import {
   FormContextValues,
   commonTranslationKeys as reactCommonTranslationKeys,
   Translate,
   useTranslate,
} from '@dreryk/react-common';
import { Select } from '@dreryk/react-components';

import { commonTranslationKeys } from '../../../../../translations';

export const StyledPayerIdentificationNumberTypeField = styled.div`
   min-width: 220px;
   max-width: 220px;
`;

StyledPayerIdentificationNumberTypeField.displayName = 'StyledPayerIdentificationNumberTypeField';

const useTriggerLabelExtractor = (): ((currentValue?: PayerIdentificationNumberType) => string) => {
   const translate = useTranslate();
   return useCallback((currentValue) => (currentValue ? translate(commonTranslationKeys[currentValue]) : ''), [
      translate,
   ]);
};

const payerIdentificationNumberTypes: PayerIdentificationNumberType[] = ['NIP', 'PESEL', 'PASSPORT_NUMBER'];

export type PayerIdentificationNumberTypeFieldProps = Pick<
   FormContextValues<{
      payers: MedicalLeavePuePayer[] | null;
   }>,
   'register'
>;

export const PayerIdentificationNumberTypeField = (props: PayerIdentificationNumberTypeFieldProps): JSX.Element => {
   return (
      <StyledPayerIdentificationNumberTypeField>
         <Select<PayerIdentificationNumberType>
            triggerLabelExtractor={useTriggerLabelExtractor()}
            controller={props.register('payers.0.identificationNumberType')}
            label={commonTranslationKeys.payerIdentificationNumberType}
            placeholder={reactCommonTranslationKeys.choose}
            testId={'payerIdentificationNumberType'}
            showClearIcon
         >
            <Select.List<PayerIdentificationNumberType> items={payerIdentificationNumberTypes}>
               {(identificationNumberType: PayerIdentificationNumberType, index: number) => (
                  <Select.Item
                     testId={identificationNumberType}
                     item={identificationNumberType}
                     label={
                        <span>
                           {index + 1}
                           {' - '}
                           <Translate>
                              {commonTranslationKeys.identificationNumberType[identificationNumberType]}
                           </Translate>
                        </span>
                     }
                  />
               )}
            </Select.List>
         </Select>
      </StyledPayerIdentificationNumberTypeField>
   );
};
